require('/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/apple/apple.module.scss.module.css');

export const appleBusinessConfigSection = "_apple-business-config-section_im98r_1";
export const appleBusinessConfigTable = "_apple-business-config-table_im98r_1";
export const appleDelegateAppleOwnership = "_apple-delegate-apple-ownership_im98r_1";
